import { Outlet } from "react-router-dom";

// Components
import Header from "./Header";
import Footer from "./Footer";

const AppLayout = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <div className="grow w-full">
        <Outlet />
      </div>
      <Footer />
    </div>
  );
};

export default AppLayout;
